import { render, staticRenderFns } from "./ListAndDetail.vue?vue&type=template&id=53f028b4&scoped=true&"
import script from "./ListAndDetail.vue?vue&type=script&lang=js&"
export * from "./ListAndDetail.vue?vue&type=script&lang=js&"
import style0 from "./ListAndDetail.vue?vue&type=style&index=0&id=53f028b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f028b4",
  null
  
)

export default component.exports